import * as React from "react"
import { FC, useEffect, useState } from "react"
import { ProfileProps, User } from "../../../../types"
import { saveUserData, saveUserProfilePhoto } from "../../../../actions"
import { connect } from "react-redux"
import { RootState } from "../../../../store"
import { KInput, KSpan } from "kahuna-base-react-components"
import UploadImage from "./UploadImage"
import { toast } from "react-toastify"
import ChangePasswordButton from "../security/ChangePasswordButton"
import { errorFilledToastOptions, infoFilledToastOptions } from "../../../../constants"
import { lang } from "../../../../constants/languages"


const Profile: FC<ProfileProps> = (props) => {
  const [initialUser, setInitialUser] = useState<User | null>(props.user)
  const [user, setUser] = useState<User | null>(props.user)
  const [loadingPhoto, setLoadingPhoto] = useState(false)

  const onFormSubmit = async (values: User) => {
    if (values.firstName === "") {
      toast.error(lang.account.profile.error.first_name_blank, errorFilledToastOptions)
      setUser((prevUser: any) => {
        return { ...prevUser, firstName: props.user.firstName }
      })
    } else if (values.lastName === "") {
      toast.error(lang.account.profile.error.last_name_blank, errorFilledToastOptions)
      setUser((prevUser: any) => {
        return { ...prevUser, lastName: props.user.lastName }
      })
    } else {
      if (
        values.firstName !== initialUser?.firstName ||
        values.lastName !== initialUser?.lastName ||
        values.bio !== initialUser?.bio
      ) {
        setInitialUser((prevUser: any) => {
          return { ...prevUser, firstName: values.firstName, lastName: values.lastName, bio: values.bio }
        })

        props.saveUserData(values)
      }
    }
  }

  const handleFirstNameChange = (newValue: string) => {
    setUser((prevUser: any) => {
      return { ...prevUser, firstName: newValue }
    })
  }
  const handleLastNameChange = (newValue: string) => {
    setUser((prevUser: any) => {
      return { ...prevUser, lastName: newValue }
    })
  }

  useEffect(() => {
    setUser(props.user)
  }, [props.user])

  const onUploadImage = (photo: FormData) => {
    setLoadingPhoto(true)
    toast.loading(lang.account.profile.loading_photo, {toastId:"LOADING_PHOTO", ...infoFilledToastOptions})
    props.saveUserProfilePhoto(photo).then(() => {
      setLoadingPhoto(false)
      toast.dismiss("LOADING_PHOTO")
    })
  }

  return (
    <>
      <div className="flex flex-col gap-6 ">
        <div>
          <UploadImage
            loading={loadingPhoto}
            sectionTitle={lang.account.profile.upload_image_title}
            sectionDetail={lang.account.profile.upload_image_desc}
            onClick={onUploadImage}
            buttonTitle={lang.account.profile.upload_image_button}
            iconPath={user?.photo || "/account_icons/avatar.svg"}
          />
        </div>
        <div className="w-full flex flex-row gap-[16px]">
          <div className="w-[calc(50%)]">
            <KInput
              value={user!.firstName}
              placeholder={lang.account.profile.first_name_placeholder}
              onChange={handleFirstNameChange}
              onBlur={() => {
                onFormSubmit(user!)
              }}
              padding="14px"
              border="1px solid #F3F3F3"
              boxShadow=" 0px 1px 2px 0px rgba(228, 229, 231, 0.24)"
            />
          </div>
          <div className="w-[calc(50%)]">
            <KInput
              value={user!.lastName}
              placeholder={lang.account.profile.last_name_placeholder}
              onChange={handleLastNameChange}
              onBlur={() => {
                onFormSubmit(user!)
              }}
              padding="14px"
              border="1px solid #F3F3F3"
              boxShadow=" 0px 1px 2px 0px rgba(228, 229, 231, 0.24)"
            />
          </div>
        </div>
        <div className="border-dashed border-b-[1px]" />
        <div className="flex justify-between" style={{ paddingRight: 1 }}>
          <div
            className="w-[calc(49%)] flex items-center"
            style={{
              borderRadius: 10,
              background: "var(--bg-weak-100, #F0F0F0)",
              padding: 14
            }}
          >
            <KSpan text={user?.email || " - "} />
          </div>
          <ChangePasswordButton />
        </div>
      </div>
    </>
  )
}

const mapStateToProps = (state: RootState) => {
  return { user: state.auth.user }
}

export default connect(mapStateToProps, { saveUserData, saveUserProfilePhoto })(Profile)
